import React from 'react';

const MobileDashboard = ({ user, taskStats, todayEvents, unreadCount, notesCount, tasks, onNavigate }) => {
  // Get items that need attention
  const getAttentionItems = () => {
    const items = [];

    // Overdue tasks
    const overdueTasks = tasks.filter(task => {
      if (task.status === 'completed' || task.assigned_to !== user?.id) return false;
      const taskDate = new Date(task.task_date);
      return taskDate < new Date().setHours(0, 0, 0, 0);
    });

    overdueTasks.slice(0, 2).forEach(task => {
      items.push({
        type: 'urgent',
        icon: '⚠️',
        title: task.title,
        subtitle: 'Overdue task',
        action: () => onNavigate('tasks')
      });
    });

    // Unread messages
    if (unreadCount > 0) {
      items.push({
        type: 'message',
        icon: '💬',
        title: `${unreadCount} unread message${unreadCount > 1 ? 's' : ''}`,
        subtitle: 'Tap to view',
        action: () => onNavigate('messages')
      });
    }

    // Today's events
    todayEvents.slice(0, 1).forEach(event => {
      items.push({
        type: 'event',
        icon: '📅',
        title: event.title,
        subtitle: event.event_time ? `Today at ${formatTime(event.event_time)}` : 'Today',
        action: () => onNavigate('calendar')
      });
    });

    return items.slice(0, 4);
  };

  const formatTime = (time) => {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const formatDate = () => {
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return new Date().toLocaleDateString('en-US', options);
  };

  const attentionItems = getAttentionItems();

  return (
    <div className="mobile-dashboard">
      {/* Dashboard Header */}
      <div className="mobile-dashboard-header">
        <div className="greeting">Good {getGreeting()}, {user?.firstName || 'there'}!</div>
        <div className="greeting-sub">Here's what's happening today</div>
        <div className="date-pill">
          <span>📅</span>
          <span>{formatDate()}</span>
        </div>
      </div>

      {/* Summary Tiles */}
      <div className="summary-grid">
        <div className="summary-tile" onClick={() => onNavigate('tasks')}>
          <div className="tile-header">
            <div className="tile-icon tasks">✓</div>
            {taskStats.overdueCount > 0 && (
              <span className="tile-badge urgent">{taskStats.overdueCount} overdue</span>
            )}
          </div>
          <div className="tile-number">{taskStats.assignedCount}</div>
          <div className="tile-label">Active Tasks</div>
        </div>

        <div className="summary-tile" onClick={() => onNavigate('calendar')}>
          <div className="tile-header">
            <div className="tile-icon calendar">📅</div>
          </div>
          <div className="tile-number">{todayEvents.length}</div>
          <div className="tile-label">Today's Events</div>
        </div>

        <div className="summary-tile" onClick={() => onNavigate('messages')}>
          <div className="tile-header">
            <div className="tile-icon messages">💬</div>
            {unreadCount > 0 && (
              <span className="tile-badge new">{unreadCount} new</span>
            )}
          </div>
          <div className="tile-number">{unreadCount}</div>
          <div className="tile-label">Unread Messages</div>
        </div>

        <div className="summary-tile" onClick={() => onNavigate('notes')}>
          <div className="tile-header">
            <div className="tile-icon notes">📝</div>
          </div>
          <div className="tile-number">{notesCount}</div>
          <div className="tile-label">Shared Notes</div>
        </div>
      </div>

      {/* Needs Attention Section */}
      {attentionItems.length > 0 && (
        <div className="attention-section">
          <div className="attention-header">Needs Attention</div>
          <div className="attention-card">
            {attentionItems.map((item, index) => (
              <div
                key={index}
                className="attention-item"
                onClick={item.action}
              >
                <div className={`attention-icon ${item.type}`}>{item.icon}</div>
                <div className="attention-content">
                  <div className="attention-title">{item.title}</div>
                  <div className="attention-subtitle">{item.subtitle}</div>
                </div>
                <span className="attention-chevron">›</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
}

export default MobileDashboard;
